import React from 'react';

import TextEditor from 'components/text_editor_new';
import { useFocusFirstPlaceholder } from 'components/text_editor_new/plugins/placeholders';
import withUseAnswers from 'components/text_editor_new/lib/with_use_answers';
import { useUpdateVariables } from 'components/text_editor_new/plugins/variables';
export default function ComposerEditor({ shouldNotUseAnswers, ...rest }) {
  return shouldNotUseAnswers ? <TextEditorWithoutAnswersMemo {...rest} /> : <TextEditorWithAnswersMemo {...rest} />;
}

const TextEditorWithAnswersMemo = React.memo(withUseAnswers(ComposerEditorBase));
const TextEditorWithoutAnswersMemo = React.memo(ComposerEditorBase);

function ComposerEditorBase(props) {
  const { editorRef } = props;
  const editor = editorRef.current;

  useUpdateVariables(editor);
  useFocusFirstPlaceholder(editor);

  return <TextEditor {...props} />;
}
